import { BehaviorSubject, Subject } from 'rxjs';
import { BestMatchHandler } from '../../Components/BestMatch/BestMatchHandler';
import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { PriceCalculationHelper } from "../../Lib/Helper/AxProdSelection/PriceCalculationHelper";
import { AxCounter } from '../../Limestone/AxCounter/AxCounter';
import { AxLimeStone } from '../../Limestone/AxLimeStone';
import { Product } from '../../Models/Tickets/Product';

@ModuleName("AxProdSelection")
export class AxProdSelection implements AxInit {

    private CultureInfo: any;
    private Divisor: number;

    public ProductList: Product[];
    public ProductListTmp: Product[];
    public InteractionSubject: BehaviorSubject<Element> = new BehaviorSubject(null);
    public SubmitSubject: Subject<Element> = new Subject<Element>();

    public ProjNr: number;
    public ProductGroupIdentifier: number;
    public Id: number;

    public Total: string;

    public Counter: AxCounter[] = [];
    public PillObeserver: IntersectionObserver;

    public foreignCurrency: string;

    private bestMatchHandler: BestMatchHandler;
    private selectedDate: moment.Moment;

    private containerSelector = ".prod_selection__prod-list";
    private totalPriceSelector = ".prod_selection__calculated-sum";
    private serviceVoucherCoverage = {};

    constructor(private _AxLimestone = new AxLimeStone()) { }

    AxInit(initData: AxProdSelectionInit) { 
        this.ProjNr = initData.ProjNr;
        this.ProductGroupIdentifier = initData.ProductGroupIdentifier;
        this.Id = initData.Id;
        this.Divisor = initData.NumberDivisor;

        this.foreignCurrency = initData.ForeignCurrency;

        this.bestMatchHandler = new BestMatchHandler(initData.GetBestMatch, this.Divisor, "div.prod_selection__betterMatch_holder", "div.prod_selection__betterMatch_packageName_holder",
            "div.prod_selection__betterMatch_betterPrice_holder", "span.prod_selection__original_SinglePrice", "div.prod_selection__calculatedPrice");

        this.SetProductList(initData.CultureInfo, initData.NumberDivisor, initData.ProductList);
        this.SetProductListTmp(this.ProductList, false);

        for (let prod of initData.ProductList) {
            let axCounter = new AxCounter();
            axCounter.Init({
                Value: prod.Quantity,
                Selector: `.prod__counter_${prod.Id}`,
                Max: prod.Max,
                Min: prod.Min,
            });
            axCounter.Subscribe((x) => {
                if (this.ProductListTmp != null) {
                    let existingEntry = this.ProductListTmp.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);
                    existingEntry.Quantity = x;

                    this.AdjustTotalAmount();
                }
            });
            this.Counter.push(axCounter);
        }

        this.PillObeserver = new IntersectionObserver(
            ([e]) => {
                e.target.toggleAttribute('stuck', e.intersectionRatio < 1)
            },
            { threshold: [1] }
        );

        this.PillObeserver.observe(document.querySelector('.ax-pill_menu'));

        $('.prod_selection__selection-submit').on('click', e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.SubmitSubject.next(this.InteractionSubject.getValue());
        });

        // Initialize service voucher coverage if available
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("serviceVoucher") === "true") {
            const personTypeIds = urlParams.getAll("personTypeId");

            personTypeIds.forEach(id => {
                if (this.serviceVoucherCoverage[id]) {
                    this.serviceVoucherCoverage[id]++;
                } else {
                    this.serviceVoucherCoverage[id] = 1;
                }
            });

            PriceCalculationHelper.initServiceVoucherCoverage(this.serviceVoucherCoverage);

            // Bind quantity change events to recalculate the total price
            PriceCalculationHelper.bindQuantityChangeEvents(this.containerSelector, this.totalPriceSelector);
        }
    };

    getSelectedDate() {
        return this.selectedDate;
    }

    SetSelectedDate(date: moment.Moment) {
        this.selectedDate = date;
    }

    SetProductListTmp(productList: Product[], informSubscriber: boolean) {
        for (let prod of productList) {
            let existingEntry = this.ProductListTmp.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);

            if (typeof existingEntry != 'undefined') {
                prod.Id = existingEntry.Id;
                prod.ListElement = existingEntry.ListElement;
                prod.Quantity = existingEntry.Quantity;
                prod.Sort = existingEntry.Sort;
            } else {
                prod.Quantity = 0;
            }
        }
        
        this.ProductListTmp = productList;
        this.AdjustTotalAmount(informSubscriber);
    }

    GetTotalQuantity(): number {
        let quantity: number = 0;
        for (let prod of this.ProductListTmp) {
            quantity += prod.Quantity;
        }

        return quantity;
    }

    SetProductList(cultureInfo: any, divisor: number, productList: Product[]) {
        this.CultureInfo = cultureInfo;
        this.Divisor = divisor;
        this.ProductList = productList;

        for (let prod of this.ProductList) {
            prod.ListElement = $('.prod_selection__prod-list')[prod.Id];
        }

        $('.prod_selection__selection-confirm').on('click', x => {
            $('#product_selection__setting_overlay').fadeToggle('fast');
            this.Apply();
        });

        $('.product_selection__setting_overlay--toggle').on('click', x => {
            this.Reset();
        });

        this.Reset();
    }

    AdjustTotalAmount(informSubscriber: boolean = true) {
        let totalAmount: number = 0;
        let totalAmountFrc: number = 0;
        let prodSummary: string = '';
        let foreignCurrency: boolean = false;

        this.bestMatchHandler.GetBestMatchTicketsV4Date(this.Id, this.ProductGroupIdentifier, this.selectedDate, this.ProductListTmp).then((bestMatchResultList) => {

            for (let prod of this.ProductListTmp) {
                if (prod.Quantity > 0) {
                    prodSummary += `${prod.Quantity} ${prod.Name}, `;

                    let bestMatchResult = this.bestMatchHandler.FindBestMatch(prod.Id, bestMatchResultList);

                    if (bestMatchResultList.length > 0) {
                        totalAmount += this.bestMatchHandler.GetBestMatchProductPriceSum(prod.Quantity, prod.Price, bestMatchResult);
                    } else {
                        totalAmount += (prod.Quantity * this.GetPrice(prod.Price));
                    }
                }

                $(prod.ListElement).find(`*[data-quantity-selection=${prod.Id}]`).html(prod.Quantity.toString());
                $(prod.ListElement).find(`*[data-quantity-input=${prod.Id}]`).val(prod.Quantity.toString());

                let price = $.number((prod.Quantity * this.GetPrice(prod.Price)), this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator,
                    this.CultureInfo.currencyGroupSeparator);

                $(prod.ListElement).find(`*[data-calculated-price=${prod.Id}]`).html(price.toString());

                if (prod.ForeignPrice != null) {
                    let priceFrc = $.number((prod.Quantity * this.GetPrice(prod.ForeignPrice)), this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator,
                        this.CultureInfo.currencyGroupSeparator);

                    $(prod.ListElement).find(`*[data-calculated-price-frc=${prod.Id}]`).html(`${this.foreignCurrency} ${priceFrc.toString()}`);
                    foreignCurrency = true;
                    totalAmountFrc += (prod.Quantity * this.GetPrice(prod.ForeignPrice));
                }
            }
            prodSummary = prodSummary.substring(0, prodSummary.length - 2);

            let totalPrice: string = this.GetPriceString(totalAmount);

            this.Total = totalPrice;

            $('.prod_selection__calculated-sum').html(totalPrice);
            $('.prod_selection__persontype-summary').html(prodSummary);

            if (foreignCurrency) {
                let totalPriceFrc: string = this.GetPriceString(totalAmountFrc);
                $('.prod_selection__calculated-sum-frc').html(`${this.foreignCurrency} ${totalPriceFrc}`);
            }

            if (informSubscriber) {
                this.InteractionSubject.next(this.InteractionSubject.getValue());
            }
        }).catch(function () { });
    }

    GetPriceString(totalAmount: number) {
        return $.number(totalAmount, this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator, this.CultureInfo.currencyGroupSeparator)
    }

    Apply() {
        this.ProductList = [];
        for (let prod of this.ProductListTmp) {
            this.ProductList.push(new Product(prod.Id, prod.Name, prod.Price, prod.OriginalPrice, prod.ForeignPrice,
                prod.Quantity, prod.SubProductIdentifier, prod.TimeSlotGroupKeys, prod.ListElement));
        }
    }

    Reset() {
        this.ProductListTmp = [];
        for (let prod of this.ProductList) {
            this.ProductListTmp.push(new Product(prod.Id, prod.Name, prod.Price, prod.OriginalPrice, prod.ForeignPrice,
                prod.Quantity, prod.SubProductIdentifier, prod.TimeSlotGroupKeys, prod.ListElement));
        }
        this.AdjustTotalAmount();
    }

    GetPrice(price: number): number {
        return price / this.Divisor;
    }
}


interface AxProdSelectionInit {
    CultureInfo: any;
    NumberDivisor: number;
    ProductList: Product[];
    ProjNr: number;
    ProductGroupIdentifier: number;
    Id: number;
    ForeignCurrency: string;
    GetBestMatch: boolean;
}
